import React from 'react';
import Box from '@mui/material/Box';

import { TIconName } from '@components/icon/types/icon-name';
import { ICONS } from '@components/icon/constants/icons';

type Props = { name: TIconName; alt: string; width?: number | string; height?: number | string; className?: string; sx?: any; disableTheming?: boolean };

export function Icon({ name, alt, width, height, className, disableTheming, ...props }: Props) {
  if (disableTheming) {
    return <img src={ICONS[name]} alt={alt} width={width || 24} height={height || 24} className={className} style={(props as any).sx} {...props} />;
  }

  return (
    <Box
      className={className}
      sx={{
        display: 'inline-block',
        width: width || 24,
        height: height || 24,
        backgroundColor: 'currentColor',
        maskImage: `url(${ICONS[name]})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${ICONS[name]})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        ...(props as any).sx
      }}
      {...props}
    />
  );
}
